module.exports = __webpack_public_path__ + "static/img/人车静态落闸识别.f85f7e24.png";